import { ReactNode } from "react"

interface Props {
  children: ReactNode
  className?: string
}

const HighlightedText = ({ children, className = "" }: Props) => (
  <span
    className={`font-medium border-dashed border-b border-stone-300 ${className}`}
  >
    {children}
  </span>
)

export default HighlightedText
